import React from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import WithProducts from "../../HOC/HOCProducts";
import ProductCard from "../Product/ProductCard";

const Kids = ({ products, handleDelete, handleAddToCart }) => {
  if (!Array.isArray(products?.products) || products.products.length === 0) {
    return (
      <Alert variant="info" className="text-center">
        No products available. <br />
        <span className="fw-bold">Check back later or contact support.</span>
      </Alert>
    );
  }

  return (
    <Container>
      <Row>
        <Container>
          <Col lg={12}>
            <h1 className="text-center hover-underline">Kids</h1>
          </Col>
        </Container>
      </Row>
      <Row className="row-xs-no-padding">
        {products.products
          .filter((product) => product.category === "Kids")
          .map((product) => (
            <Col key={product._id} lg={3} md={6} sm={6} xs={6} className="mb-3">
              <ProductCard
                product={product}
                handleDelete={handleDelete}
                handleAddToCart={handleAddToCart} />
            </Col>
          ))}
      </Row>
      <Row>
        <Col lg={12}>
          <p className="text-center">Thanks for visiting our website!</p>
        </Col>
      </Row>
    </Container>
  );
};

export default WithProducts(Kids);
